import { DataTableColumnHeader } from "../table-components/data-table-column-header";

export const financialColumns = [
  {
    id: "paymentInfo",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Payment Info" />
    ),
    accessorFn: (row) => {
      const info = row.paymentInfo;
      return info
        ? `${info.initialization || "N/A"} - $${(info.amount || 0) / 100} - ${info.status || "N/A"} - ${info.method || "N/A"}`
        : "N/A";
    },
    cell: ({ row }) => {
      const info = row.original.paymentInfo;
      if (!info) return <div>N/A</div>;

      const price = (info.amount || 0) / 100;

      return (
        <div className="flex flex-col items-start gap-1 justify-between min-w-32">
          <span className="px-2 py-1 text-xs rounded truncate bg-gray-200 text-gray-800">
            Init: {info.initialization || "N/A"}
          </span>
          <span className="px-2 py-1 text-xs rounded truncate bg-green-200 text-green-800">
            Amount: ${price}
          </span>
          <span className="px-2 py-1 text-xs rounded truncate bg-blue-200 text-blue-800">
            Status: {info.status || "N/A"}
          </span>
          <span className="px-2 py-1 text-xs rounded truncate bg-purple-200 text-purple-800">
            Method: {info.method || "N/A"}
          </span>
        </div>
      );
    },
  },
  {
    id: "stripeSessionId",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Stripe Session ID" />
    ),
    accessorKey: "stripeSessionId",
    cell: (info) => (
      <div className="font-mono text-xs truncate max-w-32">
        {info.getValue() || "N/A"}
      </div>
    ),
  },
  {
    id: "paymentIntentId",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Payment Intent ID" />
    ),
    accessorKey: "paymentIntentId",
    cell: (info) => (
      <div className="font-mono text-xs truncate max-w-32">
        {info.getValue() || "N/A"}
      </div>
    ),
  },
  {
    id: "payoutStatus",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Payout Status" />
    ),
    accessorFn: (row) => row.ShovelerInfo?.[0]?.PayoutStatus || "N/A",
    cell: ({ row }) => {
      const status = row.original.ShovelerInfo?.[0]?.PayoutStatus;
      const colors = {
        paid: "bg-green-100 text-green-800",
        failed: "bg-red-100 text-red-800",
        created: "bg-yellow-100 text-yellow-800",
        manual: "bg-blue-100 text-blue-800",
      };
      return (
        <span
          className={`px-2 py-1 text-xs rounded ${colors[status] || "bg-gray-100 text-gray-800"}`}
        >
          {status || "N/A"}
        </span>
      );
    },
  },
];
